import React, { useEffect } from 'react';
import { inject } from 'mobx-react';
import { observer } from 'mobx-react-lite';
import { Loader } from 'oned';
import { AvailabilityBusiness } from '@business/newCreateRequest/stepsItems/availability';
import './index.less';
import NewAutoSchedule from './newAutoSchedule';
import NewAvailability from './newAvailability';
var StepsAvailability = inject(AvailabilityBusiness)(observer(function (props) {
    var initData = props.initData, init = props.init, loading = props.loading, isShowAutoSchedule = props.isShowAutoSchedule;
    useEffect(function () {
        initData();
        init();
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement(Loader, { visible: loading }),
        isShowAutoSchedule && !loading && React.createElement(NewAutoSchedule, null),
        !isShowAutoSchedule && !loading && React.createElement(NewAvailability, null));
}));
export default StepsAvailability;
